import { Link } from 'foundations-components/transitional/components/Link';
import AbstractRouterLink from './internal/AbstractRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A [`Link`](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-link--basic)
 * type component with router support.
 */
export default function RouterLink(props) {
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, props, {
    component: Link
  }));
}